import { render, staticRenderFns } from "./GoogleRoute.vue?vue&type=template&id=10a525fb&scoped=true"
import script from "./GoogleRoute.vue?vue&type=script&lang=js"
export * from "./GoogleRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a525fb",
  null
  
)

export default component.exports